module.exports = __webpack_public_path__ + "img/arrow-square-up-right-dark.faad59a.svg";